import { isName, isEmail } from "./validation";

export interface RegisterValidation {
  ok: boolean;
  errors: {
    full_name?: string;
    email?: string;
    school?: string;
    city?: string;
    consent?: string;
  };
}

export function validateRegistration(input: {
  full_name: string;
  email: string;
  school_id?: string;
  school_name?: string;
  city?: string;
  consent_acknowledged: boolean;
}): RegisterValidation {
  const e: RegisterValidation["errors"] = {};
  if (!isName(input.full_name)) e.full_name = "Enter your full name (2+ chars).";
  if (!isEmail(input.email)) e.email = "Enter a valid email address.";
  const newSchool = !!(input.school_name && input.school_name.trim().length >= 3);
  if (!input.school_id && !newSchool) e.school = "Choose your school or add a new one.";
  if (newSchool && !(input.city && input.city.trim().length >= 2)) {
    e.city = "Please add the city of your school.";
  }
  if (!input.consent_acknowledged) {
    e.consent =
      "Please acknowledge that your name, school, and rank may appear on the leaderboard.";
  }
  return { ok: Object.keys(e).length === 0, errors: e };
}
